const KNOWN_BACKEND_ERROR_KEY_MAP = {
  "A user with this email already exists": "errors.duplicateEmail",
  "Email already in use": "errors.duplicateEmail",
  "Invalid email format": "admin.userForm.validation.emailInvalid",
  "Password must be at least 6 characters": "admin.userForm.validation.passwordMin",
  "You do not have permission to perform this action.": "errors.noPermission",
  "Failed to load users. Please try again.": "admin.common.failedToLoadUsers",
  "Failed to load sales data. Please try again.": "admin.common.failedToLoadSales"
};

export function mapBackendErrorToTranslationKey(errorMessage = "") {
  if (!errorMessage || typeof errorMessage !== "string") {
    return null;
  }

  if (KNOWN_BACKEND_ERROR_KEY_MAP[errorMessage]) {
    return KNOWN_BACKEND_ERROR_KEY_MAP[errorMessage];
  }

  const normalized = errorMessage.toLowerCase();

  if (normalized.includes("already") && normalized.includes("email")) {
    return "errors.duplicateEmail";
  }

  if (normalized.includes("permission") || normalized.includes("forbidden")) {
    return "errors.noPermission";
  }

  if (normalized.includes("not found")) {
    return "errors.notFound";
  }

  if (normalized.includes("network") || normalized.includes("connect")) {
    return "errors.networkError";
  }

  return null;
}

export function localizeApiError(t, error, fallbackKey = "errors.generic") {
  const backendMessage =
    error?.response?.data?.error || error?.response?.data?.message || error?.message || "";

  const mappedKey = mapBackendErrorToTranslationKey(backendMessage);
  if (mappedKey) {
    return t(mappedKey);
  }

  return t(fallbackKey);
}
